import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Guid, isNotNil } from '@web/utils';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, Observable, switchMap } from 'rxjs';
import { WarehouseProductDetails } from '../../models/warehouse-product-details';
import { WarehouseProductDataSourceService } from '../../services/warehouse-product-data-source.service';
import {
  BooleanPipe,
  DateFormatPipe,
  DetailsViewComponent,
  NoDataComponent,
  PrimengDividerDirective,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { WarehouseProductTypePipe } from '../../pipes/warehouse-product-type.pipe';
import { FetchWarehouseOwnerByIdPipe } from '../../pipes/fetch-warehouse-owner-by-id.pipe';
import { QuantityUnitComponent } from '@web/shared/module/measurement';
import { WarehouseProductQuantityHistoryListComponent } from '../warehouse-product-quantity-history-list/warehouse-product-quantity-history-list.component';
import { Divider } from 'primeng/divider';

@Component({
  selector: 'app-warehouse-product-details',
  imports: [
    CommonModule,
    SpinnerFilledComponent,
    DetailsViewComponent,
    WarehouseProductTypePipe,
    NoDataComponent,
    DateFormatPipe,
    BooleanPipe,
    FetchWarehouseOwnerByIdPipe,
    QuantityUnitComponent,
    WarehouseProductQuantityHistoryListComponent,
    Divider,
    PrimengDividerDirective,
  ],
  templateUrl: './warehouse-product-details.component.html',
  styleUrl: './warehouse-product-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseProductDetailsComponent {
  /* prettier-ignore */
  private readonly warehouseProductDataSource = inject(WarehouseProductDataSourceService);

  public readonly id = input.required<Guid>();
  public readonly owner = input.required<string>();

  protected readonly id$ = toObservable(this.id);
  protected readonly owner$ = toObservable(this.owner);

  protected readonly details$ = this.detailsSource();
  protected readonly isNotNil = isNotNil;

  private detailsSource(): Observable<WarehouseProductDetails> {
    return combineLatest({
      id: this.id$,
      owner: this.owner$,
    }).pipe(
      switchMap(({ id, owner }) =>
        this.warehouseProductDataSource.fetchDetailsById(owner, id),
      ),
    );
  }
}
